<template>
  <!-- 账号设置页面 -->
  <div class="right">
    <el-main class="contentRight setUp">
      <template>
        <el-tabs v-model="activeName" >
          <el-tab-pane label="账号设置" name="first">
            <div class="message">
              <div class="message-title">
                <span><b>公开信息</b></span>
              </div>

              <div class="message-content">
                <div class="messgae-item">
                  <div class="item-name">名称</div>

                  <div class="item-mes">{{userInfo.nickname}}</div>

                  <div class="item-right">
                    <div class="item-function">
                      <!--											<span class="function-change disable" @click="isShowUsernameInp = true" v-if="!isShowUsernameInp">修改</span>-->
                      <span class="function-change disable" @click="dialogFormVisible = true">修改</span>
                      <span class="function-change disable" @click="subCahngeUsername"
                        v-if="isShowUsernameInp">提交修改</span>
                      <div class="function-desc disable">一个自然年内可申请修改名称2次</div>
                    </div>
                    <div class="text name-history">查看
                      <!--<span class="link">改名记录</span>-->
                      <el-popover placement="top-start" title="更名记录" width="200" trigger="hover" content="正在为您更新">
                        <el-button class="link" slot="reference">改名记录</el-button>
                      </el-popover>

                    </div>
                  </div>

                </div>
                <div class="messgae-item">
                  <div class="item-name">头像</div>
                  <img class="item-img" v-if="!userInfo.headimgurl" :src="userInfo.default_img" alt="头像">
                  <img class="item-img" v-if="userInfo.headimgurl" :src="userInfo.headimgurl" alt="头像">
                  <div class="item-function avater">
                    <!--										<el-button class="function-change" @click="openHeadimg">修改头像</el-button>-->
                    <el-button class="function-change" @click="dialogFormVisible = true">修改头像
                    </el-button>
                    <div class="function-desc">一个自然月内可申请修改头像1次</div>
                  </div>
                </div>
                <div class="messgae-item">
                  <div class="message-title grxx">
                    <span><b>个人信息</b></span>
                  </div>
                  <div class="item-mes">
                    真实姓名：<span v-if="userInfo.user!=null">{{Truename}}</span>
                  </div>
                  <div class="item-function idcardmessage">
                  </div>
                </div>
                <div class="messgae-item">
                  <div class="item-mes">
                    身份证号：<span class="ml-10" v-if="userInfo.user!=null">{{userInfo.user.idnumber}}</span>
                  </div>
                  <div class="item-function idcardmessage">
                  </div>
                </div>
                <div class="messgae-item">
                  <div class="item-name" style="color:#65707e">账号类型</div>
                  <div class="item-mes" v-if="userInfo.business==1" style="color:rgb(233, 138, 85)">认证专家</div>
                  <div class="item-mes" v-if="userInfo.business==2" style="color:#5179DD">认证机构</div>
                  <div class="item-mes" v-if="userInfo.business!=2&&userInfo.business!=1" style="color:#f34">普通用户</div>
                </div>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>

        <el-dialog title="修改账号信息" :visible.sync="dialogFormVisible">
          <el-form >
            <el-form-item label="修改名称">
              <el-input v-model="userInfo.nickname" autocomplete="off"></el-input>
            </el-form-item>
            <div>修改个人头像</div>
            <el-upload class="Enterprise_LoGo_img" action="https://researchadmin.qudong.com/api/upload/headimg_upload"
              :headers="headers" :show-file-list="false" multiple name="image" :on-success="successAgreements"
              :before-upload="beforeRef">
              <img v-if="imageUrls" :src="imageUrls" @mouseenter="xianshitishi" @mouseleave="buxianshi" class="Enterprise_LoGos">
              <!-- <i v-else class="el-icon-plus Enterprise_LoGo_img_icon"></i> -->
              <img v-else class="Enterprise_LoGos" @mouseenter="xianshitishi" @mouseleave="buxianshi" :src="userInfo.headimgurl==''?userInfo.default_img:userInfo.headimgurl" alt="">
              <div v-if="isxianshi==true" class="yiruxianshi">修改头像</div>
            </el-upload>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="ModifyInformation()">确 定</el-button>
          </div>
        </el-dialog>
      </template>
    </el-main>

  </div>
</template>
<!--0-大众  1自媒体，2商家媒体，3群媒体，4新闻媒体，5国家机构 6企业 7 其他组织 user-->
<!--类型 0-群媒体 1新闻 2 国家机构 3 企业 4 其他组织 oginfo-->
<script>
import { update_img,Infos,img_sign,userInfos } from "@/api/api";
//个人信息修改
// import {ChangeNickname} from '@/request/api';
// import {ChangeDesc} from '@/request/api';
// //个人信息
// import {UserInfo} from '@/request/api';
// import {shuiyin_index} from '@/request/api';
// import {shuiyin_save} from '@/request/api';
//机构信息
//import { OrganizationUserInfo } from '@/request/api';
import Axios from "axios";
let token = localStorage.getItem("token");
export default {
   inject: ["reload"],
  metaInfo(){
     return{
        title: '账号设置',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  name: "AccountSeetings",
  data() {
    return {
      headers: {
        token: token,
      }, //请求头传toke
      imageUrls: "",
      dialogFormVisible: false, //修改签名
      msg: "设置首页",
      userInfo: '',
      //   userInfo1: "",
      activeName: "first",
      isShowUsernameInp: false,
      shuiyin: 0,
      tabName: "kaiqi",
      isxianshi:false,
      userid:'',
      Business:'',
      Truename:'',
    };
  },
  methods: {
    xianshitishi(){
      this.isxianshi=true;
    },
    buxianshi(){
    this.isxianshi=false;
    },
    ModifyInformation() {
      var that=this;
      //console.log(this.userInfo.nickname);
      //console.log(this.imageUrls);
      // console.log(that.userInfo.id)
      // console.log(that.userInfo.business)
       var headimgurl=''
      if (that.imageUrls != "") {
        headimgurl=that.imageUrls
      } else {
          headimgurl=that.userInfo.headimgurl
      }
          Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/user/update_img",
      params: {
          nickname:that.userInfo.nickname,
        headimgurl,
        qudong_id:that.userid,
        business:that.Business,
      },
      headers: {
          token: localStorage.getItem("token"),
        },
    }).then((res) => {
      //console.log(res);
        if (res.data.code == 200) {
          that.$message.success(res.data.msg);
          setTimeout(that.$router.go(0),1000);
        } else {
          that.$message.success(res.data.msg);
        }
    });


      // update_img({
      //   nickname:that.userInfo.nickname,
      //   headimgurl,
      //   qudong_id:that.userid,
      //   business:that.Business,
      // }).then((res) => {
      //   //console.log(res);
      //   if (res.data.code == 200) {
      //     that.$message.success(res.data.msg);
      //     setTimeout(that.$router.go(0),1000);
      //   } else {
      //     that.$message.success(res.data.msg);
      //   }
      // });
    },
    // 请求前限制上传条件
    beforeRef(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG || !isLt2M) {
        this.$message.error("上传文件只能是图片格式，且大小不能超过2M");
        return false;
      }
      return isJPG, isLt2M;
    },
    // 账号头像
    successAgreements(res) {
      var that = this;
      that.imageUrls = res.data[0];
      that.$message.success(res.msg);
    },
    tabClick(tab, event) {
      //console.log(tab, event);
      //console.log(tab.index);
      var index = tab.index;
      if (index == 0) {
        //添加水印
        this.shuiyin = 1;
      }
      if (index == 1) {
        //不添加水印
        this.shuiyin = 0;
      }
    },

    baocunshuiyin: function () {
      // shuiyin_save({shuiyin:this.shuiyin}).then(res => {
      //     this.$notify({
      //         title: '成功',
      //         message: '已保存配置',
      //         type: 'success'
      //     });
      //     return false;
      // })
    },

    // 查询用户是否开启了水印
    shuiyin_init: function () {
      // shuiyin_index({desc: this.form.desc}).then(res => {
      //     if (res.code == 200) {
      //        this.shuiyin = 1;
      //        this.tabName = "kaiqi"
      //     } else {
      //         this.shuiyin = 0;
      //         this.tabName = "guanbi"
      //     }
      //     return false;
      // })
    },


    //获取个人信息
    getUserInfo() {
    //    userInfos({}).then((res) => {
    //   console.log(res);
    //   //  this.userInfo = res.data.data;
    // });
       Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/user/infos",
      params: {
        
      },
      headers: {
          token: localStorage.getItem("token"),
        },
    }).then((res) => {
      console.log(res);
          if (res.data.code == 200) {
              this.userInfo = res.data.data;
              this.Business=res.data.data.business;
              this.userid=res.data.data.id;
              this.Truename=res.data.data.user.truename;
              // this.reload();
          } else {
              this.$message({
                  message: res.data.msg, 
                  type: 'warning'
              });
            //   this.$router.push({path: '/login'}); //跳转
          }
    });


    },


    subCahngeUsername() {

      this.isShowUsernameInp = false;
    },
  },
  created() {
 this.getUserInfo();
  },
  mounted() {


  },
};
</script>

<style scoped>
.right {
  width: 940px;
}
.el-header {
  background: #ffffff;
  border: 1px solid #ebebeb;
  padding: 5px 0;
}

.innerheader {
  width: 1080px;
  margin: auto;
  height: 60px;
}

.el-main {
  padding: 0;
}

.innerheader .headerRight {
  display: inline-block;
  float: right;
}

.innerheader .headerRight .imgWrap {
  width: 36px;
  height: 36px;
  border-radius: 36px;
  overflow: hidden;
  display: inline-block;
}

.waitting {
  color: #008643;
}

.passed {
  color: #00feff;
}

.nopass,
.notcomplete {
  color: darkred;
  width: 500px !important;
}

.infostatus {
  padding: 15px;
}

.infostatus div {
  width: 120px;
}

.innerheader .headerRight .imgWrap img {
  max-width: 100%;
  height: 100%;
}

.middleContent {
  width: 1080px;
  margin: 15px auto;
}

.el-menu {
  border-right: none;
}

.contentRight {
  padding: 30px;
}

.el-footer {
  margin-top: 100px;
}

.footerBar {
  width: 800px;
  margin: auto;
  font-size: 12px;
  color: #c0c0c0;
}

.footerBar .el-col {
  border-right: 1px solid #c0c0c0;
  text-align: center;
}

.footerBar .el-col:nth-child(4) {
  border-right: none;
}

.beian {
  font-size: 12px;
  color: #c0c0c0;
  text-align: center;
  margin: 15px auto 40px;
}

.el-menu-item-group__title {
  display: none;
}

/*设置*/

.setUp {
  background: #ffffff;
}

.setUp .auth {
  margin-top: 10px;
  margin-bottom: 20px;
  padding: 0 0 20px;
  background: #fff;
  font-size: 14px;
  color: #65707e;
  border-bottom: 1px solid #eee;
}

.setUp .auth .auth-name {
  width: 100px;
  float: left;
  height: 70px;
  line-height: 36px;
  padding: 17px 0;
}

.setUp .auth .auth-type {
  overflow: hidden;
  padding: 17px 0;
  margin-left: 97px;
}

.setUp .auth .weibo-login-on .has-bind-info {
  height: 36px;
  line-height: 36px;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -ms-flex-positive: row nowrap;
  flex-grow: row nowrap;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
>>> .el-dialog {
  width: 580px;
}
.setUp .auth .weibo-login-on .has-bind-info .lose-weibo-contact {
  text-decoration: none;
  color: #409eff;
}

.setUp .message {
  font-size: 14px;
}

.setUp .message .message-title {
  background: #fff;
  height: 50px;
  line-height: 50px;
  padding: 0;
  font-size: 16px;
  color: #65707e;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.setUp .message .message-content .messgae-item {
  padding: 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  clear: both;
  overflow: hidden;
}

.setUp .message .message-content .messgae-item .item-name {
  float: left;
  height: 70px;
  line-height: 70px;
  padding: 0;
  width: 100px;
}

.setUp .message .message-content .messgae-item .item-mes {
  min-height: 70px;
  line-height: 70px;
  padding: 0;
  display: inline-block;
  max-width: 500px;
  margin-left: 0;
  word-break: break-all;
  word-wrap: break-word;
  color: #65707e;
}

.setUp .message .message-content .messgae-item .item-right {
  float: right;
}

.setUp .message .message-content .messgae-item .item-function {
  text-align: right;
  width: 240px;
  margin-top: 15px;
  float: right;
}

.setUp .message .message-content .messgae-item .item-function .disable {
  color: #bdc2c9;
}

.setUp .message .message-content .messgae-item .name-history {
  text-align: right;
  font-size: 12px;
}

.setUp .message .message-content .messgae-item .name-history .link {
  color: #2397ee;
  border: none;
  padding: 0;
}

.setUp .message .message-content .messgae-item .item-img {
  width: 40px;
  height: 40px;
  margin: 20px 15px;
  border-radius: 50%;
}

.setUp .message .message-content .messgae-item .item-function .function-change {
  color: #2397ee;
  cursor: pointer;
  border: none;
  padding: 0;
}

.setUp .message .message-content .messgae-item .item-function .function-desc {
  margin-top: 0;
  font-size: 12px;
  color: #65707e;
}

a,
a:focus,
a:hover,
a:visited {
  outline: none;
  text-decoration: none;
}

a,
a:hover,
a:visited {
  color: #2397ee;
  cursor: pointer;
}

.card1 div,
.card2 div {
  position: relative;
  width: 450px;
  height: 300px;
  margin-bottom: 30px;
}

.card1 span {
  display: inline-block;
  height: 21px;
  /* background: url("../../assets/img/watermark.png") no-repeat; */
  position: absolute;
  bottom: 5px;
  right: 5px;
  padding-left: 85px;
  color: #fff;
}

.card1 img,
.card2 img {
  width: 450px;
  height: 300px;
}

#wm_tab {
  padding-left: 85px;
  position: relative;
  top: -10px;
}

.wm_txt {
  position: relative;
  top: 20px;
}

.card1 button,
.card2 button {
  margin-bottom: 30px;
}

.setUp .message .message-content .messgae-item .item-name[data-v-e3c1b0d4] {
  width: auto;
  margin-right: 10px;
}

.grxx {
  margin-top: 50px;
}
.Enterprise_LoGo_img {
  width: 96px;
  height: 96px;
  cursor: pointer;
  background-image: url("../../assets/img/HeadPortrait.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-left: 21px;
  margin: 30px 0;
  
  position:relative;
}
.Enterprise_LoGo_img .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.Enterprise_LoGo_img .el-upload:hover {
  border-color: #409eff;
}
.Enterprise_LoGo_img_icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px;
  height: 96px;
  line-height: 160px;
  border-radius: 50%;
  text-align: center;
}
.Enterprise_LoGos {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: block;
  background: #fff;
}
.yiruxianshi{
  background:#000000;
  opacity: 0.8;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  text-align:center;
  line-height:96px;
  color:#fff;
  position:absolute;
  top:0;
  pointer-events:none;
}
</style>
